<template>
	<span :title="model">
		<v-autocomplete
			:loading="loading"
			:search-input.sync="search"
			:multiple="multiple"
			:filter="filter"
			v-model="model"
			persistent-hint
			:hint="hint"
			@change="update()"
			:disabled="disabled"
			:items="itemsData"
			:rules="computedRules"
			:label="label"
			item-value="_id"
			clearable
		>
			<template slot="selection" slot-scope="data">
				<span v-if="data.index === model.length - 1"> {{ getDataText(data.item) }} </span>
				<span v-if="data.index !== model.length - 1"> {{ getDataText(data.item) }} ,</span>
			</template>
			<template slot="item" slot-scope="data">
				{{ getDataText(data.item) }}
			</template>
		</v-autocomplete>
	</span>
</template>

<script>
import BaseInput from './baseInput'
export default {
	data() {
		return {
			itemsData: [],
			search: '',
			loading: false,
			searchTimeout: null,
		}
	},
	extends: BaseInput,
	props: ['modelName', 'multiple'],
	methods: {
		update(value) {
			if (this.search && this.search.length > 0) {
				this.search = ''
			}
			this.$emit('input', this.model)
			this.$emit('change', this.model)
		},
		async getItemsData() {
			this.itemsData = await this.$store.getters.searchData(this.modelName, this.search)
			this.loading = false
		},
		getDataText(data) {
			return this.$store.getters.formatData(this.modelName, data)
		},
		filter(item, queryText, itemText) {
			return true
			// FILTER IS DONE SERVER SIZE
		},
	},
	watch: {
		search() {
			this.loading = true
			if (this.searchTimeout) {
				clearTimeout(this.searchTimeout)
			}
			this.searchTimeout = setTimeout(this.getItemsData, 1000)
		},
	},
	async mounted() {
		await this.getItemsData(this.modelName)
	},
}
</script>



// WEBPACK FOOTER //
// src/baseComponents/inputs/dataInput.vue